import { render } from "./BuildfixIcon.vue?vue&type=template&id=2f909d20&scoped=true"
import script from "./BuildfixIcon.vue?vue&type=script&lang=js"
export * from "./BuildfixIcon.vue?vue&type=script&lang=js"

import "./BuildfixIcon.vue?vue&type=style&index=0&id=2f909d20&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f909d20"]])

export default __exports__